export default "__VITE_ASSET__d0a0c994__"